import React, { useContext, useEffect, useRef, useState } from 'react'
import { ModalContext } from '@nv/contexts'
import { BrowserMultiFormatReader, NotFoundException } from '@zxing/library'
import { useTranslation } from 'react-i18next'
import styles from './BarcodeScanner.module.scss'
import { Select } from '@nv/basic-components'

export const BarcodeScanner = () => {
  const { t } = useTranslation()
  const [barcode, setBarcode] = useState('')
  const [scannedId, setScannedId] = useState('')
  const [videoDevices, setVideoDevices] = useState([])
  const [selectedDeviceId, setSelectedDeviceId] = useState('')
  const videoRef = useRef(null)
  const codeReader = useRef(null)
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)

  useEffect(() => {
    setHeaderLabel(t('Barcode Scanner'))
    setBtns([
      { text: t('buttons.cancel'), onClick: onClose, isCancel: true },
      { text: t('buttons.confirm'), onClick: onClose },
    ])
  }, [setHeaderLabel, setBtns, onClose, t])

  useEffect(() => {
    codeReader.current = new BrowserMultiFormatReader()

    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        stream.getTracks().forEach((track) => track.stop())
        return codeReader.current.listVideoInputDevices()
      })
      .then((devices) => {
        setVideoDevices(devices)
        if (devices.length > 0) {
          setSelectedDeviceId(devices[0].deviceId)
        }
      })
      .catch((err) => {
        console.error('Camera permission or device error:', err)
      })

    return () => {
      codeReader.current?.reset()
      codeReader.current = null
    }
  }, [])

  // Initialize codeReader and get devices
  // useEffect(() => {
  //   codeReader.current = new BrowserMultiFormatReader()

  //   codeReader.current
  //     .listVideoInputDevices()
  //     .then((devices) => {
  //       setVideoDevices(devices)
  //       if (devices.length > 0) {
  //         setSelectedDeviceId(devices[0].deviceId)
  //       } else {
  //         console.error('No video input devices found')
  //       }
  //     })
  //     .catch((err) => {
  //       console.error('Error listing video devices:', err)
  //     })

  //   return () => {
  //     // cleanup on unmount
  //     codeReader.current?.reset()
  //     codeReader.current = null
  //   }
  // }, [])

  // Start scanning when selectedDeviceId changes
  useEffect(() => {
    if (!selectedDeviceId) return

    setBarcode('')
    setScannedId('')
    codeReader.current?.reset()

    codeReader.current.decodeFromVideoDevice(selectedDeviceId, videoRef.current, (result, error) => {
      if (result) {
        const text = result.getText()
        setBarcode(text)
        setScannedId(text.slice(0, 8))
        console.log('Barcode scanned:', text)
      } else if (error && !(error instanceof NotFoundException)) {
        console.warn('ZXing error:', error)
      }
    })

    // Cleanup on device change or unmount
    return () => {
      codeReader.current?.reset()
    }
  }, [selectedDeviceId])

  return (
    <div className={styles['container']}>
      <Select
        label={t('Select camera:')}
        options={videoDevices.map((device) => ({
          label: device.label || `Camera ${device.deviceId}`,
          value: device.deviceId,
        }))}
        value={selectedDeviceId}
        onChange={(value) => setSelectedDeviceId(value)}
        isRequired={true}
        ariaLabel={t('Select camera:')}
      />

      <video ref={videoRef} className={styles['camera']} muted autoPlay playsInline />

      <div>
        <strong>{t('Full Barcode:')}</strong> {barcode || t('(waiting for scan...)')}
      </div>
      <div>
        <strong>{t('Short ID:')}</strong> {scannedId || t('(waiting for scan...)')}
      </div>
    </div>
  )
}
